import React, { useCallback, useEffect, useState } from 'react';
import './InfoPanel.less';
import { getInfoPanelContext } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Edit/InputData/DataDesignerService';
import { PropertyGrid } from 'components/property-editors/PropertyGrid';
import { registerEditorAndGetSnapshot } from '@decisions/server/DecisionsFramework/Design/Properties/ContextProviderService';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';

export interface IInfoPanelProps {
  sessionId: string;
}

export function InfoPanel({ sessionId }: IInfoPanelProps) {
  const [snapshot, setSnapshot] = useState<ContextProviderNode | undefined>(undefined);

  const refreshSnapshot = useCallback(async () => {
    const id = await getInfoPanelContext({ sessionId });
    const snapshot = await registerEditorAndGetSnapshot({ contextProviderRegistrationId: id });
    setSnapshot(snapshot);
  }, [sessionId]);

  useEffect(() => {
    refreshSnapshot();
  }, [refreshSnapshot]);

  return <div className="dpc-input-designer-info">{!!snapshot && <PropertyGrid snapshot={snapshot} />}</div>;
}
